import Button from '@components/Button'
import FilterChip from '@components/Chip'
import searchFilters from 'map/filters'
import styles from './styles.module.scss'

const getFilterTranslation = value => {
    let result = ''
    searchFilters.map(searchFilter =>
        searchFilter.options.filter(option => {
            if (value === option.value) {
                result = option.label
            }
        })
    )
    return result
}

const FilterChipContainer = ({ filters = {}, removeFilter, clearFilters }) => (
    <>
        <div className={styles.filterChipContainer}>
            {Object.keys(filters).length !== 0 &&
                Object.keys(filters).map(
                    (filter, index) =>
                        filter != null && (
                            <FilterChip
                                key={index}
                                handleRemove={() => removeFilter(filter)}
                                label={<T>{getFilterTranslation(filter)}</T>}
                            />
                        )
                )}
        </div>
        {Object.keys(filters).length !== 0 && (
            <div className={styles.resetButton}>
                <Button onClick={clearFilters} btnStyle="link" size="small" align="right">
                    <T>map.filter.reset.all</T>
                </Button>
            </div>
        )}
    </>
)

export default FilterChipContainer
